module.exports = __webpack_public_path__ + "img/zhcs.6b905737.png";